import React from "react";

const SectionDivider = () => (
  <div style={{ borderTop: "1px solid #E5EAEE", margin: "10px 0px" }} />
);

export { SectionDivider };
